import { MasterTranslation } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { TrackingWidget } from '@/modules/pmt/components/TrackingWidget';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { useEmailSyncPopup } from '@/modules/pmt/hooks';
import { gtmViewLoginCta } from '@/utils';
import { type FC, type JSX, useEffect } from 'react';
import { Divider, ESDefaultContent, ESMainText, JoinUsButton } from '../../DefaultTrackingContainer.styles';
import { useESDefaultBannerCopy } from './hooks/useESDefaultBannerCopy.hook';

interface IESDefaultBannerProps {
  squareAd?: JSX.Element;
  searchShipments: (trackingIds: string[]) => void;
}
export const ESDefaultBanner: FC<IESDefaultBannerProps> = ({ squareAd, searchShipments }) => {
  const { t } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const { notificationTranslation } = useMyParcelsContext();
  const { openEmailSyncPopup } = useEmailSyncPopup();
  const { mainTextDesktop, mainTextMobile, buttonText } = useESDefaultBannerCopy();

  const mainText = isDesktopPMT ? mainTextDesktop : mainTextMobile;

  useEffect(() => {
    gtmViewLoginCta(notificationTranslation.identifier);
  }, []);

  return (
    <>
      <ESDefaultContent>
        <img
          src='/images/tracking-default-image.svg'
          alt='tracking-default-image'
          width={isDesktopPMT ? 290 : 236}
          height={isDesktopPMT ? 160 : 130}
          style={{
            objectFit: 'contain',
          }}
        />
        <ESMainText>{mainText}</ESMainText>
      </ESDefaultContent>
      <JoinUsButton onClick={openEmailSyncPopup}>{buttonText}</JoinUsButton>
      <Divider>
        <span>{t(MasterTranslation.Or)}</span>
      </Divider>
      {/* TW input + Add parcels button */}
      <TrackingWidget handleSubmit={searchShipments} isDisabled />
      {squareAd}
    </>
  );
};
